import { Flame } from 'lucide-react';
import { motion } from 'motion/react';

interface UrgentBadgeProps {
  variant?: 'default' | 'large';
  animate?: boolean;
}

export function UrgentBadge({
  variant = 'default',
  animate = true,
}: UrgentBadgeProps) {
  const isLarge = variant === 'large';

  return (
    <motion.div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        border: '1px solid var(--warning-border)',
        backgroundColor: 'var(--warning-background)',
        borderColor: 'var(--warning-border)',
        borderRadius: '9999px', // Full pill shape
        paddingLeft: isLarge ? '10px' : '8px',
        paddingRight: isLarge ? '10px' : '8px',
        paddingTop: isLarge ? '6px' : '3px',
        paddingBottom: isLarge ? '6px' : '3px',
        minHeight: isLarge ? '32px' : '22px',
      }}
      initial={animate ? { scale: 0.9, opacity: 0 } : undefined}
      animate={animate ? { scale: 1, opacity: 1 } : undefined}
      transition={
        animate
          ? {
              type: 'spring',
              stiffness: 500,
              damping: 20,
            }
          : undefined
      }
    >
      <Flame
        className={isLarge ? 'w-4 h-4' : 'w-3.5 h-3.5'}
        style={{
          color: 'var(--warning-foreground)',
          fill: 'var(--warning-foreground)',
          width: isLarge ? '16px' : '14px',
          height: isLarge ? '16px' : '14px',
        }}
      />
      <span
        style={{
          fontSize: 'var(--text-xs)',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--warning-foreground)',
          lineHeight: 'normal',
        }}
      >
        Urgente
      </span>
    </motion.div>
  );
}
